





































import router from '@/router'
import Vue from 'vue'
import mixin from './cardmixin.vue'
import { WorkRecordStatisticsServiceProxy,WorkRecordReportSelectDTO } from '@/service-proxies/app-v2/work-record.service-proxies'
import { mapActions } from 'vuex'
const workRecordStatisticsServiceProxy = new WorkRecordStatisticsServiceProxy()
export default Vue.extend({
  name: 'work-record',
  mixins: [mixin],
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions({
      generateRoutes: 'permission/generateRoutes',
      saveMakinoJump: 'app/saveMakinoJump'
    }),
    async getList() {
      this.data = await workRecordStatisticsServiceProxy.getWorkRecordStatistics(new WorkRecordReportSelectDTO())
    },
    async goRouter(value) {
      const data = await this.generateRoutes('ops') // 动态增加路由
      this.$store.commit('permission/SET_ROUTES', data)
      this.$store.commit('permission/SET_APP_ROUTE_MAP', {
        appCode: 'ops',
        appName: '运维系统',
        routes: data.length ? data[0].children : []
      })
      router.addRoutes(
        data.concat({
          path: '*',
          redirect: '/404'
        })
      )
      this.saveMakinoJump(value)
      this.$router.push('/ops/work-record-list')
    }
  }
})
